// extracted by mini-css-extract-plugin
export var footerHeading = "footer-module--footerHeading--2cdd7";
export var footerLogo = "footer-module--footerLogo--03bc7";
export var footerText = "footer-module--footerText--6b588";
export var mailIcon = "footer-module--mailIcon--c2069";